import { CharacterCardActions as CharacterCardActionsV2 } from "@next-platform/client-common-spicy-ui";

import { Collection } from "@/types/api";
import { HitConfig, HitItem } from "@/types/hits";

import { CharacterCardDropdownActions } from "../types";
import getHitCharacterConfig from "./getHitCharacterConfig";
import getHitLorebookConfig from "./getHitLorebookConfig";
import getHitRulebookConfig from "./getHitRulebookConfig";

interface IGetHitConfigProps {
  hits: HitItem[];
  likedBots: string[];
  likedLorebooks?: string[];
  onlyUserId?: string | null;
  chatLanguage: string;
  dislikedRecommendedCharacterIds: string[];
  localizePathname: (path: string) => string;
  t: (key: string) => string;
  translateTag: (tag: string) => string;
  blurNSFW: boolean;
  isPartner: boolean;
  isAgeVerificationRequired: boolean;
  isAuthenticated: boolean;
  /** Rulebook hits only: the viewer may attach a rulebook to a character or persona. */
  canAttachRulebook?: boolean;
  hasVoiceAttachmentFeatureFlag: boolean;
  characterCardActionsHandler: (action: CharacterCardActionsV2 | CharacterCardDropdownActions, characterId: string, isNsfw?: boolean) => void;
  /** False while the draft store isn't scoped to a signed-in account — Rulebook clones write there. */
  isRulebookDraftReady?: boolean;
  collection?: Collection;
}

/**
 * Returns the character hit config array based on provided parameters.
 */
export function getHitConfig({ collection = Collection.CHARACTERS, ...props }: IGetHitConfigProps): HitConfig[] {
  return (props.hits || []).map((character) => {
    if (collection === Collection.RULEBOOKS) {
      return getHitRulebookConfig({
        rulebook: character as HitItem,
        t: props.t,
        translateTag: props.translateTag,
        isAuthenticated: props.isAuthenticated,
        canAttach: props.canAttachRulebook,
        characterCardActionsHandler: props.characterCardActionsHandler,
        isRulebookDraftReady: props.isRulebookDraftReady,
      }) as HitConfig;
    }
    if (collection === Collection.LOREBOOKS) {
      return getHitLorebookConfig({
        lorebook: character as HitItem,
        t: props.t,
        translateTag: props.translateTag,
        isAuthenticated: props.isAuthenticated,
        characterCardActionsHandler: props.characterCardActionsHandler,
        likedLorebooks: props.likedLorebooks,
        onlyUserId: props.onlyUserId,
      }) as HitConfig;
    }
    return getHitCharacterConfig({
      ...props,
      character: character as HitItem,
    }) as HitConfig;
  });
}
